import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import { UserSendPasswordResetMutationVariables } from "../../types";

export const USER_SEND_PASSWORD_RESET = gql`
  mutation userSendPasswordReset($email: String!, $redirectUrl: String!) {
    userSendPasswordReset(email: $email, redirectUrl: $redirectUrl) {
      message
    }
  }
`;

export type UserSendPasswordResetData = { userSendPasswordReset: { message: string } };

export default (
  options?: MutationHookOptions<UserSendPasswordResetData, UserSendPasswordResetMutationVariables>
) => {
  return useMutation<UserSendPasswordResetData, UserSendPasswordResetMutationVariables>(
    USER_SEND_PASSWORD_RESET,
    options
  );
};
